$(document).ready(function() {
    const keypointsSlider = new Flickity('.keypoints-slider', {
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: true,
        groupCells: true,
        prevNextButtons: true,
        autoPlay: 5000
    });
    $(document).on('click','.comparison-item-switch .active-item', function(){
        const dropdown = $(this).siblings('.items-list');
        const dropdownHeight = dropdown.find('.list-inner').outerHeight();
        $(this).parent().toggleClass('open');
        $('.comparison-item-switch').not($(this).parent()).removeClass('open');
        $('.comparison-item-switch').not($(this).parent()).find('.items-list').css('height', 0);
        if($(this).parent().hasClass('open')){
            dropdown.css('height', dropdownHeight);
        }else{
            dropdown.css('height', 0);
        }
    });

    $(document).on('click', function(e){
        if (!$(e.target).closest('.comparison-item-switch').length) {
            $('.comparison-item-switch').removeClass('open');
            $('.comparison-item-switch .items-list').css('height', 0);
        }
    });

    $(document).on('click','.comparison-item-switch .items-list .item', function(){
        const $this = $(this);
        const id = $this.data('index');

        const newOrder = $(this).parents('.comparison-table-header_cell').attr('data-order');
        const newIndex = $(this).parents('.comparison-table-header_cell').attr('data-index');

        const target = $('.item-cell[data-index="'+id+'"]');
        const currentOrder = target[0].style.order;
        const source = $('.item-cell[data-index="'+newIndex+'"]');

        target.attr('data-order', newOrder).css('order', newOrder);
        source.attr('data-order', currentOrder).css('order', currentOrder);

        $this.closest('.comparison-item-switch').removeClass('open');
        $this.closest('.comparison-item-switch').find('.items-list').css('height', 0);

    });

    //on click anchor link starting with #, scroll to the target
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        const hrefVal = $(this).attr('href');
        if(hrefVal === '#'){
            return;
        }
        const target = $(hrefVal);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 0);
        }
    });

    $(document).on('click', '.open-video-popup', function(e) {
        e.preventDefault();
        const videoId = $(this).data('video');
        const videoEl = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoId + '?loop=1&autoplay=1&mute=1&playlist=' + videoId + '&iv_load_policy=3&disablekb=1&controls=0&playsinline=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        $('.box-video-popup .popup-video').empty().html(videoEl);
        $('.box-video-popup').addClass('active');
    });
    $(document).on('click', '.box-video-popup .popup-overlay,.box-video-popup .popup-close', function() {
        $('.box-video-popup').removeClass('active');
        $('.box-video-popup .popup-video').empty();
    });

});